import DOMPurify from 'dompurify'

export const stripHTML = (originalString: string) => DOMPurify.sanitize(originalString, { ALLOWED_TAGS: [] })
